import { render, staticRenderFns } from "./verificationCodeButton.vue?vue&type=template&id=30378486&scoped=true&"
import script from "./verificationCodeButton.vue?vue&type=script&lang=js&"
export * from "./verificationCodeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30378486",
  null
  
)

export default component.exports